import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-inapp-reg',
  templateUrl: './inapp-reg.component.html',
  styleUrls: ['./inapp-reg.component.scss'],
})
export class InappRegComponent {
  pass; hide; numCd = "+91"; numb; fName; lName; email; org; loader:boolean = false;
   gender: any;  genderName;
  maxlength ='9';
  staffAdmin: boolean = false;
  type;
  catArray:any=[]
  constructor(   private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService,private bottomSheet: MatBottomSheet) { }

    ionViewWillEnter(){
      this.gender=1;
      this.genderName="Male"
      this.org=sessionStorage.getItem('orgCd');
      var y = JSON.parse(sessionStorage.getItem('category'));
      y.map(res=>{
        this.catArray.push(res.id)
      })
    }

  register() {  
    if(this.org && this.org != "") {
      if(!this.loader && this.fName && this.lName && this.numb && this.email)
        if(this.fName) {
          this.fName = this.fName.toUpperCase();
        }
      if(this.lName) {
        this.lName = this.lName.toUpperCase();
      }
      if(this.org) {
        this.org = this.org.toUpperCase();
      }
    
      var post = {
        contactNbrMob: this.numCd + this.numb,
        firstName: this.fName.toUpperCase(),
        lastName: this.lName,
        userType: 1,
        category:this.catArray,
        orgCode: this.org,
        emailId: this.email,
        genderCd:this.gender,
        appId: 14,
        verified:true,
        paless: true,
        staffAdminInd: this.staffAdmin,
        roles: ["SP"]
      }
     this.loader = true;
      this.service.registerInapp(post).subscribe(
        (res: any) => {
          sessionStorage.clear();
          this.router.navigate(['/user']);
          this.loader = false;
          this.handler.res('Registered Successfully !!')
        },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
    }
    else {
      this.handler.res("Please Enter The Org Code");
    }
  }

  openGender(): void {
    let genders = [
      {name:'Male',id:"1"},
      {name:'Female',id:"2"}
    ]
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: genders,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.genderName = res.name;
      this.gender = res.id;
    });
  }

  ionViewWillLeave(){  
    this.numb="";
    this.fName="";
   this.lName="";
    this.email="";
    sessionStorage.removeItem("orgCd");
    sessionStorage.removeItem("orgId");
  }


}
